// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"90242352","645":"90242352","677":"76c7970e"}[chunkId] + ".chunk.css";
};